import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { deleteTask, formEditable, changeTaskStatus } from './../../actions';
import './task.scss';

class Task extends Component {
    state = {
        ...this.props.settings
    };
    taskHeader = null;
    taskStatus = () => {
        !this.state.animate && this.setState({...this.state, 'animate': true});
        this.props.changeTaskStatus(this.state.id, !this.state.done);
    };
    showTaskDetails = () => {
        this.props.history.push('/task-details', this.state);
    };
    editTask = () => {
        this.props.formEditable(true, this.state);
    };
    deleteTask = () => {
        this.props.deleteTask(this.state.id);
        if (this.props.editStatus &&
            this.state.id === this.props.taskDetails.id) {
            this.props.formEditable(false);
        }
    };
    componentWillReceiveProps(nextProps) {
        this.setState({...nextProps.settings});
    }
    render() {
        let statusAnimate = this.state.animate ? 'animate' : '',
            statusDone = this.state.done ? 'done' : 'undone';
        return (
            <div className={`task ${statusDone} ${statusAnimate}`}
                 ref={node => this.taskHeader = node}
            >
                <div className='task-container form-group d-flex align-items-center my-1'>
                    <input type='checkbox'
                           className='task-check mr-1'
                           onChange={this.taskStatus}
                           checked={!!this.state.done}
                    />
                    <input className='task-title form-control'
                           readOnly={true}
                           value={this.state.title}
                           onClick={this.showTaskDetails}
                    />
                    <button className='btn btn-warning'
                            onClick={this.editTask}
                    >&#9998;
                    </button>
                    <button className='btn btn-danger' onClick={this.deleteTask}>&times;</button>
                </div>
            </div>
        )
    }
}

export default withRouter(connect(
    state => ({
        editStatus: state.editable,
        taskDetails: state.taskDetails
    }),
    dispatch => ({
        'deleteTask': id => {
            dispatch(deleteTask(id))
        },
        'formEditable': (bool, taskDetails) => {
            dispatch(formEditable(bool, taskDetails))
        },
        'changeTaskStatus': (id, done) => {
            dispatch(changeTaskStatus(id, done))
        }
    })
)(Task));